module.exports = __webpack_public_path__ + "img/H5.ac983045.png";